"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsThemeAlreadySet = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const ThemeProvider_js_1 = require("../../ThemeProvider/ThemeProvider.js");
const useIsomorphicLayoutEffect_js_1 = require("./useIsomorphicLayoutEffect.js");
const index_js_1 = require("../functions/index.js");
/**
 * Hook that returns a boolean ref which is true if either:
 * - There is a parent `ThemeProvider` in the tree, or
 * - The <body> element has data-iui-theme attribute
 */
const useIsThemeAlreadySet = (ownerDocument = (0, index_js_1.getDocument)()) => {
    const parentContext = React.useContext(ThemeProvider_js_1.ThemeContext);
    const isThemeAlreadySet = React.useRef(!!parentContext || !!(ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.body.dataset.iuiTheme));
    (0, useIsomorphicLayoutEffect_js_1.useIsomorphicLayoutEffect)(() => {
        if (parentContext ||
            (ownerDocument && !!ownerDocument.body.dataset.iuiTheme)) {
            isThemeAlreadySet.current = true;
        }
        return () => {
            isThemeAlreadySet.current = false;
        };
    }, [parentContext, ownerDocument]);
    return isThemeAlreadySet;
};
exports.useIsThemeAlreadySet = useIsThemeAlreadySet;
